import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
/**
 * Renders children in a collapsible quote section.
 *
 * Note: Because this component is used in shadow-dom the we cannot use Habla,
 * and the styles the way they are normally used.
 */
export const EmailReplyQuote = ({ children, }) => {
    const contentRef = useRef(null);
    const [maxHeight, setMaxHeight] = useState(0);
    const toggleQuote = useCallback(() => { var _a, _b; return setMaxHeight(maxHeight ? 0 : (_b = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0); }, [maxHeight]);
    return (_jsxs("div", Object.assign({ className: "reply-quote-root" }, { children: [_jsx("div", { children: _jsx("button", Object.assign({ className: "reply-quote-button", onClick: toggleQuote }, { children: "\u00B7\u00B7\u00B7" })) }), _jsx("div", Object.assign({ style: { maxHeight }, className: "reply-quote-content" }, { children: _jsx("div", Object.assign({ ref: contentRef }, { children: children })) }))] })));
};
